
export default {
    head() {
        return {
            title: this.pageData.metatitle,
            meta: [
                {
                    hid: 'description',
                    name: 'description',
                    content: this.pageData.metadesc,
                }
            ],
        }
    },

    data() {
        return {
            pageData: null,
        };
    },

    asyncData(context) {
        return context.$axios
            .get('/narratorcomps/genre/' + context.route.params.genre)
            .then((res) => {
                return {
                    pageData: res.data,
                }
            })
            .catch((e) => {
                context.error({ statusCode: 404 })
            })
    },

    methods: {
        changeGenre(genre) {
            this.pageData.h1 = genre.h1 ?? genre.title
            this.pageData.metatitle = genre.metatitle ?? genre.title
            this.pageData.metadesc = genre.metadesc
            this.pageData.text = genre.text
        }
    },

}
